export enum CustomerStatusType {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  BLOCKED = 'BLOCKED',
  INACTIVE = 'INACTIVE',
}
